import {
	aertechnicaImage,
	depurecoImage,
	coralLogo,
	sibiliaLogo,
	iso9001,
	ceMark,
	vcaLogo,
	icimLogo,
	dnvLogo,
	allcertLogo,
	vokaLogo,
	atexColorIcon,
	partnersImage,
	depurecoHero,
	coralHero,
	sibiliaHero,
} from '../../assets/images/images';

export const ABOUT_US_CONFIG = {
	user: [
		{
			img: '',
			name: 'Niels De Muynck',
			email: 'niels@aertech.be',
		},
		{
			img: '',
			name: 'Edwin De Muynck',
			email: 'edwin@aertech.be',
		},
	],
	certification: [
		{
			img: iso9001,
			alt: 'ISO 9001 - ISO 1400',
		},
		{
			img: atexColorIcon,
			alt: 'ATEX',
		},
		{
			img: ceMark,
			alt: 'European certificate of conformity',
		},
		{
			img: vcaLogo,
			alt: 'Veiligheids Checklist Aannemers',
		},
		{
			img: icimLogo,
			alt: 'Istituto di Certificazione Italiano per la Meccanica',
		},
		{
			img: dnvLogo,
			alt: 'management system certification',
		},
		{
			img: allcertLogo,
			alt: 'all cert systems',
		},
		{
			img: vokaLogo,
			alt: 'Vlaams Netwerk van Ondernemingen',
		},
	],
	partners: {
		household: {
			slider: [partnersImage],
			partners: [{
				img: aertechnicaImage,
				name: 'Aertecnica',
				href: 'http://www.aertecnica.com/',
			}],
		},
		industrial: {
			slider: [depurecoHero, coralHero, sibiliaHero],
			partners: [{
				img: depurecoImage,
				name: 'Depureco',
				href: 'http://www.depureco.com/',
			},
			{
				img: sibiliaLogo,
				name: 'Sibilia',
				href: 'http://www.sibilia.it/en/',
			},
			{
				img: coralLogo,
				name: 'Coral',
				href: 'https://coralnorthamerica.com/',
			}],
		},
	},
};



// WEBPACK FOOTER //
// ./src/pages/about-us/about-us.config.js